"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

module.exports = Object.freeze(Object.create(null, {
  __unenv__: {
    get: () => true
  }
}));